const HIGHLIGHTS_ROUTES = {
  path: '/store-highlights',
  component: () =>
    import('@/pages/StoreHighlights/HighlightsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'store-highlights.index',
      component: () => import('@/pages/StoreHighlights/HighlightsPage.vue'),
    },
    {
      path: 'create',
      name: 'store-highlights.create',
      component: () => import('@/pages/StoreHighlights/HighlightsFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'store-highlights.edit',
      component: () => import('@/pages/StoreHighlights/HighlightsFormPage.vue'),
    },
  ],
};

export default HIGHLIGHTS_ROUTES;
